<template>
  <div class="animated fadeIn">
    <div id="user-list">
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i>
              User List
              <b-button
                @click="addUser"
                size="sm"
                title="Add User"
                style="float: right;margin-bottom: 5px;"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
              </b-button>
            </div>
            <div class="card-body">
              <b-table striped hover :items="users" :fields="fields">
                <template slot="commands" slot-scope="row">
                  <b-button
                    size="sm"
                    variant="info"
                    title="Edit User"
                    class="active"
                    @click="editUser(row)"
                  >
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import ajax from '@/resources/myApi.js';

export default {
  name: 'UserList',
  data() {
    return {
      fields: ['commands', 'fullname', 'email', 'phoneNumber'],
      users: [],
      isLoading: false
    };
  },
  methods: {
    editUser({ item: { id } }) {
      this.$router.push({ name: 'EditUser', params: { id } });
    },
    addUser() {
      this.$router.push({ name: 'AddUser' });
    }
  },
  created() {
    let loader = this.$loading.show();
    ajax.get('api/user').then(response => {
      console.log(response);
      this.users = response.data.items;
      //this.isLoading = false;
      loader.hide();
    });
  }
};
</script>

